@keyframes _10hd6s50 {
  0% {
    opacity: 0;
    transform: scale(0) translateZ(0);
  }
  66.666% {
    opacity: 1;
    transform: scale(1.2) translateZ(0);
  }
  100% {
    opacity: 0.5;
    transform: scale(0) translateZ(0);
  }
}
@keyframes _10hd6s51 {
  0% {
    opacity: 0;
    transform: scale(0) translateZ(0);
  }
  33.333% {
    opacity: 1;
    transform: scale(1.2) translateZ(0);
  }
  66.666% {
    opacity: 1;
    transform: scale(0) translateZ(0);
  }
  100% {
    opacity: 0;
    transform: scale(0) translateZ(0);
  }
}
@keyframes _10hd6s52 {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
._10hd6s53 {
  position: relative;
  display: inherit;
}
._10hd6s54 {
  animation: 750ms ease-out 1 _10hd6s52;
  animation-fill-mode: forwards;
}
._10hd6s55 {
  position: absolute;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  will-change: transform;
}
._10hd6s55 path {
  fill: var(--pluma-palette-yellow-500);
}
._10hd6s56 {
  width: 13px;
  height: 13px;
  animation: 2700ms ease-in infinite _10hd6s51;
  top: -1px;
  left: -8px;
}
._10hd6s57 {
  width: 8px;
  height: 8px;
  animation: 2000ms ease-in infinite _10hd6s50;
  bottom: -2px;
  left: -3px;
}
._10hd6s58 {
  width: 7px;
  height: 7px;
  animation: 3150ms ease-in infinite _10hd6s50;
  top: 2px;
  right: -5px;
}
._10hd6s59 {
  width: 11px;
  height: 11px;
  animation: 2850ms ease-in infinite _10hd6s50;
  bottom: -4px;
  right: -4px;
}
._10hd6s5a {
  width: 11px;
  height: 11px;
  animation: 2080ms ease-in infinite _10hd6s51;
  top: -4px;
  right: -1px;
}